import {Job} from '@/generated/graphql'
import { TableCell} from '@mui/material'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableBody from '@mui/material/TableBody'
import React from 'react'
import {shortenDate} from '@/utils/dateUtils'
import CancelJobButton from '@/components/pages/JobsPage/CancelJobButton'
import MuiTableContainer from '@/components/common/MuiTableContainer'
import { StyledTableHeader } from '@/components/common/CustomStyledComponents'

type DatabaseTableProps = {
    jobs: Job[]
}

const DatabaseTable = ({jobs}: DatabaseTableProps) => {
    return (
        <MuiTableContainer maxHeight='70vh'>
            <TableHead>
                <TableRow>
                    <StyledTableHeader>Id</StyledTableHeader>
                    <StyledTableHeader>Database id</StyledTableHeader>
                    <StyledTableHeader>Database name</StyledTableHeader>
                    <StyledTableHeader>Database description</StyledTableHeader>
                    <StyledTableHeader>State</StyledTableHeader>
                    <StyledTableHeader>Submitted date</StyledTableHeader>
                    <StyledTableHeader>Start date</StyledTableHeader>
                    <StyledTableHeader>End date</StyledTableHeader>
                    <StyledTableHeader>Action</StyledTableHeader>
                </TableRow>
            </TableHead>
            <TableBody>
                {jobs.map((job: Job, idx) => (
                    <TableRow key={job.id + '-' + idx}>
                        <TableCell>{job.id}</TableCell>
                        <TableCell>{job.database_id}</TableCell>
                        <TableCell>{job.database_name}</TableCell>
                        <TableCell>{job.database_description}</TableCell>
                        <TableCell>{job.state}</TableCell>
                        <TableCell>{shortenDate(job.submitted_date)}</TableCell>
                        <TableCell>{shortenDate(job.start_date)}</TableCell>
                        <TableCell>{shortenDate(job.end_date)}</TableCell>
                        <TableCell>
                            <CancelJobButton job={job} type='database'/>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </MuiTableContainer>

    )
}

export default DatabaseTable